import { Location, NgOptimizedImage } from '@angular/common';
import { Component, effect, input, signal } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { Router, RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { MenuItem } from '../side-nav.models';

@Component({
    selector: 'side-nav-menu',
    templateUrl: './side-nav-menu.component.html',
    styleUrl: './side-nav-menu.component.scss',
    standalone: true,
    imports: [MatListModule, MatMenuModule, NgOptimizedImage, RouterLink, TranslatePipe]
})
export class SideNavMenuComponent {
    collapsed = input(false);
    item = input.required<MenuItem>();
    level = input.required<number>();
    nestedMenuOpen = signal(false);

    constructor(
        private router: Router,
        private location: Location
    ) {
        effect(
            () => {
                if (this.collapsed()) {
                    this.nestedMenuOpen.set(false);
                }
            },
            { allowSignalWrites: true }
        );
    }

    itemClasses(item: MenuItem): Record<string, boolean> {
        const active = this.isActive(item);
        return {
            active,
            active0: this.level() === 0 && active && !!item.subItems
        };
    }

    isActive(item: MenuItem): boolean {
        const currentUrl = this.router.url.split('?')[0];
        if ('route' in item) {
            return currentUrl.startsWith(`/${item.route}`);
        } else {
            return item.subItems.some((sub) => this.isActive(sub));
        }
    }

    routeClick() {
        if (this.item().route === window.location.pathname.slice(1)) this.location.historyGo(0);
    }

    unCollapedClick() {
        if (this.item().subItems) {
            this.nestedMenuOpen.update((value) => !value);
        } else {
            this.routeClick();
        }
    }
}
